export default __webpack_public_path__ + "static/media/load.f986ff88.gif";